import { BoundAutocomplete } from "lib/@components/binding/bound-components"
import { useBoundValue } from "lib/@components/binding/use-bound-value"
import { getAuthoringScheduleTypes } from "authoring/routes/project/controller/get-authoring-schedule-types"

export function ScheduleTypesAutocomplete() {
    const scheduleTypes = getAuthoringScheduleTypes.useResultsOnce() ?? []
    const typeIds = scheduleTypes.map((t) => t.id)
    const [selectedTypes] = useBoundValue("legacyScheduleTypes", [])
    const hasSelection = selectedTypes?.length > 0
    const helperText = hasSelection ? "" : "Is required"

    return (
        <BoundAutocomplete
            sx={{ mt: 2 }}
            field="legacyScheduleTypes"
            label="Schedule Types"
            error={!hasSelection}
            multiple
            defaultValue={[]}
            textFieldProps={{ required: true }}
            helperText={helperText}
            options={typeIds}
            getOptionLabel={(id) => scheduleTypes.find((t) => t.id === id)?.name ?? String(id)}
            isOptionEqualToValue={(option, value) => option === value}
        />
    )
}
